import React, { useState } from "react";
import "./About.scss";
import { useNavigate, useLocation } from "react-router-dom";
import HeaderNavigate from "../../components/headerNavigate/HeaderNavigate";
import { useCustomSearchParams } from "../../components/hooks/useCustomSearchParams";
import { SEARCH_PARAMS } from "../../utils/SearchParams";
import ImageContainer from "../../components/imageContainer/ImageContainer";
import chorus_work from "../../components/assets/chorus_work.png";

const About = () => {
  const navigate = useNavigate();
  const { get, set } = useCustomSearchParams();
  const location = useLocation();
  const funderName = location.state?.funderName || "Funder";

  return (
    <div className="about-page-container container-fluid text-dark mb-5 p-0">
      <div className="container p-0">
        <div className="title-block ps-0">
          <h4 className="text-muted">
            About the CHORUS Dashboards and Reporting Service
          </h4>
        </div>

        <div className="mb-4">
          {/* The CHORUS Dashboards and Reporting Service are a suite of online
          monitoring and reporting tools that help funders, institutions,
          publishers, and researchers track compliance with open access mandates
          for publicly funded research, providing dynamic data visualizations to
          see which articles are publicly available and meet requirements. These
          dashboards simplify monitoring by collecting metadata to published
          work, and offering customization for funders and institutions to
          manage the administrative burden of open access policies. */}
          The CHORUS Dashboards and Reporting Service is a suite of online
          monitoring and reporting tools that help funders, institutions,
          publishers, and researchers track compliance with open access mandates
          for publicly funded research. The service provides dynamic data
          visualizations showing which articles are publicly available and meet
          requirements, while collecting and linking metadata to published
          works. Funders and institutions can also customize dashboards to
          reduce the administrative burden of managing open access policies.
        </div>

        <div className="mb-4">
          <h4>Key Features & Functions:</h4>
          <ul>
            <li>
              Visualize open access compliance by tracking articles reporting on
              funded research.
            </li>
            <li>
              Offers tailored dashboards for stakeholders to monitor their
              investments.
            </li>
            <li>
              Directs users to the publicly available version of research
              articles on publisher sites, enhancing discoverability and access.
            </li>
            <li>
              APIs and reports allow data downloads and integration into other
              portals.
            </li>
          </ul>
        </div>

        <div className="mb-4">
          <img
            src={chorus_work}
            alt="About CHORUS Dashboards"
            className="img-fluid mx-auto d-block w-75"
          />
        </div>

        <div className="mb-4">
          <h4> Who Uses the Dashboards?</h4>
          <ul>
            <li>
              Funding Agencies: To ensure their funded research becomes publicly
              accessible.
            </li>
            <li>
              Academic Institutions: To monitor author compliance and support
              accountability.
            </li>
            <li>
              Publishers: To streamline reporting and meet mandates efficiently.
            </li>
            <li>
              Researchers: To understand requirements and track their own
              compliance.
            </li>
            <li>The Public: To find openly available research.</li>
          </ul>
        </div>

        <div className="mb-4">
          <h5>Notes:</h5>
          <p className="mb-2 ms-3">
            Dataset types are retrieved from the metadata provided by the
            Dataset Source. CHORUS does not normalize the data retrieved for
            datasets.
          </p>
        </div>
      </div>
    </div>
  );
};

export default About;
